import { KeyedResource } from './keyed.resource';

export class NavigationResource extends KeyedResource {
  private navigationNameImpl: string;

  constructor(args: any) {
    super(args, args.actionName);
    const self: any = this;
    self.resourceType = 'navigation';
    self.navigationNameImpl = this.uiResourceName;
  }

  public get navigationName() {
    return this.navigationNameImpl;
  }
}
